import React from 'react';
import { StudyGuideLessonDataGrid } from './study-guide-lesson-data-grid';
import { DialogContent, DialogTitle } from '@/components/ui/dialog';

export function StudyGuideLessonModal(props) {
  const { data } = props;

  return (
    <DialogContent size="lg">
      <DialogTitle border>Aulas iniciadas</DialogTitle>

      <StudyGuideLessonDataGrid
        data={data}
        height={366}
      />
    </DialogContent>
  );
}
